export const requiredDatasetFields: { [key: string]: string } = {
	context: 'Отсутствует контекст описания объекта',
	provider: 'Отсутствует объект провайдера',
	providerName: 'Отсутствует краткое название, которое отображается в интерфейсе, ' +
		'и является уникальным идентификатором',
	accountId: 'Отсутствует идентификатор пользователя услуг в вашей компании (номер абонента и т.п.)',
	totalPaymentDue: 'Отсутствует полная сумма для оплаты',
	price: 'Отсутствует обязательное поле price в объекте totalPaymentDue',
	priceCurrency: 'Отсутствует обязательное поле priceCurrency в объекте totalPaymentDue',
	paymentDue: 'Отсутствует крайний срок оплаты в формате https://en.wikipedia.org/wiki/ISO_8601',
};

export const datasetCodeValidationErrors: { [key: string]: string } = {
	incorrectPrice: 'Поле price в объекте totalPaymentDue должно быть числом ' +
		'(разделителем в дробных числах должна быть точка, например 400.5)',
	incorrectDate: 'Поле billingPeriod введено некорректно (правильный формат YYYY-MM-DD)',
};

export const datasetVisualValidationErrors: { [key: string]: string } = {
	incorrectPrice: 'Сумма платежа является обязательным полем и должна быть числом ' +
		'(разделителем в дробных числах должна быть точка, например 400.5)',
};

export const optionalDatasetFields: { [key: string]: string } = {
	type: 'Отсутствует тип описываемого объекта',
	providerType: 'Отсутствует поле @type объекта provider',
	providerLegalName: 'Отсутствует поле legalName объекта provider',
	providerLogo: 'Отсутствует поле logo объекта provider',
	minimumPaymentDue: 'Отсутствует минимальная сумма для оплаты',
	minimumPaymentDueType: 'Отсутствует поле type в объекте minimumPaymentDue',
	minimumPaymentDuePrice: 'Отсутствует поле price в объекте minimumPaymentDue',
	minimumPaymentDuePriceCurrency: 'Отсутствует поле priceCurrency в объекте minimumPaymentDue',
	totalPaymentDueType: 'Отсутствует поле type в объекте totalPaymentDue',
	description: 'Отсуствует назначение платежа, которое будет показано юзеру в интерфейсе',
	customer: 'Отсутствует плательщик',
	customerType: 'Отсутствует поле type объекта customer',
	customerName: 'Отсутствует поле name объекта customer',
	customerAddress: 'Отсутствует поле address объекта customer',
	customerTelephone: 'Отсутствует поле telephone объекта customer',
	billingPeriod: 'Отсутствует период выставленного счёта в указанном формате',
	url: 'Отсутствует ссылка на объект счёта на внешнем ресурсе' +
		'(например, ссылка на скачивание pdf-файла с выставленным счётом)',
	image: 'Отсутствует ссылка на preview картинки (Ожидаем картинку в разрешении 630×380 px)',
};

export const requiredPromoFields: { [key: string]: string } = {
	merchant: 'Отсутствует обязательный объект merchant',
	merchantName: 'Отсутствует краткое название, оно же уникальный идентификатор компании',
	orderNumber: 'Отсутствует номер заказа',
	priceCurrency: 'Отсутствует обязательное поле priceCurrency',
	price: 'Отсутствует обязательное поле price',
	acceptedOffer: 'Отсутствует детальное описание заказа',
	acceptedOfferItemOffered: 'Отсутствует обязательный объект itemOffered объекта acceptedOffer',
	name: 'Отсутствует название',
	acceptedOfferPriceCurrency: 'Отсутствует обязательное поле priceCurrency объекта acceptedOffer',
	acceptedOfferPrice: 'Отсутствует обязательное поле price объекта acceptedOffer',
	acceptedOfferEligibleQuantity: 'Отсутствует обязательный объект eligibleQuantity объекта acceptedOffer',
	eligibleQuantityValue: 'Отсутствует обязательное поле value объекта eligibleQuantity',
};

export const optionalPromoFields: { [key: string]: string } = {
	context: 'Отсутствует поле @context',
	type: 'Отсутствует поле @type',
	merchantType: 'Отсутствует поле @type объекта merchant',
	mechantLegalName: 'Отсутствует поле legalName объекта merchant',
	acceptedOfferType: 'Отсутствует поле @type объекта acceptedOffer',
	acceptedOfferItemType: 'Отсутствует поле @type в объекте itemOffered',
	acceptedOfferItemUrl: 'Отсутствует поле url в объекте itemOffered',
	acceptedOfferItemImage: 'Отсутствует поле image в объекте itemOffered',
	acceptedOfferEligibleQuantityType: 'Отсутствует поле @type в объекте eligibleQuantity',
	url: 'Отсутствует ссылка на заказ',
};

export const DOCUMENTATION_HREF = 'https://help.mail.ru/developers/jsonld';

export const UIDL = '15481495260000000783';

export const SKINS = {
	0: 'dataset',
	1: 'promo',
};

export const MONTHS = [
	'Январь',
	'Ферваль',
	'Март',
	'Апрель',
	'Май',
	'Июнь',
	'Июль',
	'Август',
	'Сентябрь',
	'Октябрь',
	'Ноябрь',
	'Декабрь',
];

export const billExample: PaymentInfo = {
	'@context': 'http://schema.org',
	'@type': 'Invoice',
	provider: {
		'@type': 'Organization',
		name: 'MailRu',
		legalName: 'Mail.Ru Group',
		logo: 'https://img.imgsmail.ru/pm/1.0.4/blocks/ph-logo/img/logotype-mail.ru.png',
	},
	accountId: 'user12345',
	minimumPaymentDue: {
		'@type': 'PriceSpecification',
		price: '100',
		priceCurrency: 'RUB',
	},
	totalPaymentDue: {
		'@type': 'PriceSpecification',
		price: '400.5',
		priceCurrency: 'RUB',
	},
	description: 'Абонентская плата за апрель 2018',
	paymentDue: '2018-10-28T08:00:00+03:00',
	customer: {
		'@type': 'Person',
		name: 'Федорова В.В.',
		address: 'Алтайский край, г. Барнаул, Солнечная поляна, д.43, к.72',
		telephone: '+79254273486',
	},
	billingPeriod: '2018-10-28',
	url: 'https://www.omfgdogs.com/test?usr=123',
	image: 'https://previews.com/preview1',
};

export const incompleteOrderExample = {
	'@context': 'http://schema.org',
	'@type': 'Order',
	merchant: {
		'@type': 'Organization',
		name: 'MailRuGames',
		legalName: 'Официальное название организации',
	},
	orderNumber: '123-4567890-1234567',
	priceCurrency: 'RUB',
	price: '539.00',
	acceptedOffer: {
		'@type': 'Offer',
		itemOffered: {
			'@type': 'Product',
			name: 'Gothic 3',
			url: 'https://games.mail.ru/play/game/gothic3/',
			image: 'https://games.mail.ru/pre_310x0_resize/pic/play/game2/picture/2017/8/1ade4ca5a019.jpeg',
		},
		price: '249.99',
		priceCurrency: 'RUB',
		eligibleQuantity: {
			'@type': 'QuantitativeValue',
			value: '1',
		},
	},
	url: 'https://games.mail.ru/play/game/order/123-4567890-1234567',
};

export const socials = [
	{
		href: 'https://vk.com/e_mail_ru',
		icon: 'https://img.imgsmail.ru/static.promo/calls/landing/vk.svg',
	},
	{
		href: 'https://ok.ru/emailru',
		icon: 'https://img.imgsmail.ru/static.promo/calls/landing/ok.svg',
	},
	{
		href: 'https://www.facebook.com/why.mail.ru/',
		icon: 'https://img.imgsmail.ru/static.promo/calls/landing/fb.svg',
	},
	{
		href: 'https://twitter.com/e_mail_ru',
		icon: 'https://img.imgsmail.ru/static.promo/calls/landing/twitter.svg',
	},
];

export const links = [
	{
		name: 'О компании',
		href: 'https://corp.mail.ru/ru/',
	},
	{
		name: 'Блог',
		href: 'https://blog.mail.ru/',
	},
	{
		name: 'Помощь',
		href: 'https://help.mail.ru/mail',
	},
];
